import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(_vm.container, {
    tag: "component",
    class: _vm.container === 'v-container' ? `pa-0 ${_vm.hideBorderOnCollapse ? 'hiddenBorder mb-0' : 'exp01ff mb-4'}` : '',
    attrs: {
      "fluid": ""
    }
  }, [_c(VMenu, {
    staticClass: "menu",
    attrs: {
      "close-on-content-click": _vm.closeOnSelect
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function ({
        on,
        attrs
      }) {
        return [_vm._t("activator", function () {
          return [_c(VTextField, _vm._g(_vm._b({
            staticClass: "input-truncate",
            attrs: {
              "value": _vm.displayText,
              "dense": _vm.dense,
              "disabled": _vm.disabled,
              "outlined": "",
              "readonly": "",
              "hide-details": ""
            },
            scopedSlots: _vm._u([{
              key: "prepend-inner",
              fn: function () {
                return [_c(VIcon, {
                  staticStyle: {
                    "margin-right": "6px"
                  },
                  attrs: {
                    "color": _vm.disabled ? null : _vm.color
                  }
                }, [_vm._v("fal fa-calendar-alt")])];
              },
              proxy: true
            }, {
              key: "append",
              fn: function () {
                return [_c(VIcon, [_vm._v(_vm._s(_vm.getExpandIcon(attrs['aria-expanded'])))])];
              },
              proxy: true
            }], null, true)
          }, 'v-text-field', attrs, false), on))];
        }, null, {
          on,
          attrs
        })];
      }
    }], null, true)
  }, [_c(VCard, [_c(VList, [_c(VListItem, [_c(VRow, {
    staticClass: "pa-0 cols-2",
    staticStyle: {
      "min-width": "0"
    }
  }, [_c(VCol, [_c(VForm, {
    ref: "formDatePicker",
    attrs: {
      "lazy-validation": ""
    },
    model: {
      value: _vm.isDatePickerFormValid,
      callback: function ($$v) {
        _vm.isDatePickerFormValid = $$v;
      },
      expression: "isDatePickerFormValid"
    }
  }, [_c('core-date-time-picker-field', {
    ref: "inputStart",
    attrs: {
      "label": _vm.isRange ? _vm.$i18n_t('Core.DateTimePicker.startDate') : _vm.$i18n_t('Core.DateTimePicker.dateTime'),
      "value": _vm.getLocaleDateFromUnix(_vm.startDate),
      "dateValue": _vm.startDate,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "rules": [_vm.inputValidationRules.validDate, _vm.inputValidationRules.validRangeStart],
      "minDate": _vm.minDate,
      "maxDate": _vm.maxDate,
      "firstDayOfWeek": "1",
      "data-cy": "start-date"
    },
    on: {
      "date:changed": _vm.handleStartDateChange,
      "date:picked": _vm.handleStartDatePicked
    }
  }), _vm.isRange ? _c('core-date-time-picker-field', {
    ref: "inputEnd",
    attrs: {
      "label": _vm.$i18n_t('Core.DateTimePicker.endDate'),
      "value": _vm.getLocaleDateFromUnix(_vm.endDate),
      "dateValue": _vm.endDate,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "rules": [_vm.inputValidationRules.validDate, _vm.inputValidationRules.validRangeEnd],
      "minDate": _vm.minDate,
      "maxDate": _vm.maxDate,
      "firstDayOfWeek": "1",
      "data-cy": "end-date"
    },
    on: {
      "date:changed": _vm.handleEndDateChange,
      "date:picked": _vm.handleEndDatePicked
    }
  }) : _vm._e(), _vm.hideApply === false ? _c(VBtn, {
    class: `v-btn-x v-btn--rounded bg-rounded-button-${_vm.color}`,
    attrs: {
      "disabled": !_vm.isDatePickerFormValid,
      "color": _vm.color,
      "text": "",
      "data-cy": "date-save-button"
    },
    on: {
      "click": _vm.handleApplyClick
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.$i18n_t('Core.DateTimePicker.buttonApply')) + "\n                ")]) : _vm._e(), _vm._t("actions", null, null, {
    apply: _vm.handleApplyClick
  })], 2)], 1), !_vm.disableQuickRanges ? _c(VCol, [_vm.isRange ? _c('ul', {
    staticClass: "quickRangeList"
  }, [_c('li', {
    staticClass: "text-subtitle-2 quickRangeListSectionHeader"
  }, [_vm._v("\n                  " + _vm._s(_vm.$i18n_t('Core.DateTimePicker.sectionRangesRelative')) + "\n                ")]), _vm.isValidQuickRange(`now${_vm.mathOp}5m`) ? _c('li', [_c(VBtn, {
    attrs: {
      "text": "",
      "small": ""
    },
    on: {
      "click": function ($event) {
        return _vm.handleQuickRangeClick(`now${_vm.mathOp}5m`);
      }
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.$i18n_tc(`Core.DateTimePicker.rangeItems.relative.${_vm.futureRange ? 'next' : 'last'}Minutes`, 5, {
    n: 5
  })) + "\n                  ")])], 1) : _vm._e(), _vm.isValidQuickRange(`now${_vm.mathOp}15m`) ? _c('li', [_c(VBtn, {
    attrs: {
      "text": "",
      "small": ""
    },
    on: {
      "click": function ($event) {
        return _vm.handleQuickRangeClick(`now${_vm.mathOp}15m`);
      }
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.$i18n_tc(`Core.DateTimePicker.rangeItems.relative.${_vm.futureRange ? 'next' : 'last'}Minutes`, 15, {
    n: 15
  })) + "\n                  ")])], 1) : _vm._e(), _vm.isValidQuickRange(`now${_vm.mathOp}30m`) ? _c('li', [_c(VBtn, {
    attrs: {
      "text": "",
      "small": ""
    },
    on: {
      "click": function ($event) {
        return _vm.handleQuickRangeClick(`now${_vm.mathOp}30m`);
      }
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.$i18n_tc(`Core.DateTimePicker.rangeItems.relative.${_vm.futureRange ? 'next' : 'last'}Minutes`, 30, {
    n: 30
  })) + "\n                  ")])], 1) : _vm._e(), _vm.isValidQuickRange(`now${_vm.mathOp}1h`) ? _c('li', [_c(VBtn, {
    attrs: {
      "text": "",
      "small": ""
    },
    on: {
      "click": function ($event) {
        return _vm.handleQuickRangeClick(`now${_vm.mathOp}1h`);
      }
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.$i18n_tc(`Core.DateTimePicker.rangeItems.relative.${_vm.futureRange ? 'next' : 'last'}Hours`, 1, {
    n: 1
  })) + "\n                  ")])], 1) : _vm._e(), _vm.isValidQuickRange(`now${_vm.mathOp}2h`) ? _c('li', [_c(VBtn, {
    attrs: {
      "text": "",
      "small": ""
    },
    on: {
      "click": function ($event) {
        return _vm.handleQuickRangeClick(`now${_vm.mathOp}2h`);
      }
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.$i18n_tc(`Core.DateTimePicker.rangeItems.relative.${_vm.futureRange ? 'next' : 'last'}Hours`, 2, {
    n: 2
  })) + "\n                  ")])], 1) : _vm._e(), _vm.isValidQuickRange(`now${_vm.mathOp}6h`) ? _c('li', [_c(VBtn, {
    attrs: {
      "text": "",
      "small": ""
    },
    on: {
      "click": function ($event) {
        return _vm.handleQuickRangeClick(`now${_vm.mathOp}6h`);
      }
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.$i18n_tc(`Core.DateTimePicker.rangeItems.relative.${_vm.futureRange ? 'next' : 'last'}Hours`, 6, {
    n: 6
  })) + "\n                  ")])], 1) : _vm._e(), _vm.isValidQuickRange(`now${_vm.mathOp}12h`) ? _c('li', [_c(VBtn, {
    attrs: {
      "text": "",
      "small": ""
    },
    on: {
      "click": function ($event) {
        return _vm.handleQuickRangeClick(`now${_vm.mathOp}12h`);
      }
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.$i18n_tc(`Core.DateTimePicker.rangeItems.relative.${_vm.futureRange ? 'next' : 'last'}Hours`, 12, {
    n: 12
  })) + "\n                  ")])], 1) : _vm._e(), _vm.isValidQuickRange(`now${_vm.mathOp}24h`) ? _c('li', [_c(VBtn, {
    attrs: {
      "text": "",
      "small": ""
    },
    on: {
      "click": function ($event) {
        return _vm.handleQuickRangeClick(`now${_vm.mathOp}24h`);
      }
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.$i18n_tc(`Core.DateTimePicker.rangeItems.relative.${_vm.futureRange ? 'next' : 'last'}Hours`, 24, {
    n: 24
  })) + "\n                  ")])], 1) : _vm._e(), _vm.isValidQuickRange(`now${_vm.mathOp}2d`) ? _c('li', [_c(VBtn, {
    attrs: {
      "text": "",
      "small": ""
    },
    on: {
      "click": function ($event) {
        return _vm.handleQuickRangeClick(`now${_vm.mathOp}2d`);
      }
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.$i18n_tc(`Core.DateTimePicker.rangeItems.relative.${_vm.futureRange ? 'next' : 'last'}Days`, 2, {
    n: 2
  })) + "\n                  ")])], 1) : _vm._e(), _vm.isValidQuickRange(`now${_vm.mathOp}7d`) ? _c('li', [_c(VBtn, {
    attrs: {
      "text": "",
      "small": ""
    },
    on: {
      "click": function ($event) {
        return _vm.handleQuickRangeClick(`now${_vm.mathOp}7d`);
      }
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.$i18n_tc(`Core.DateTimePicker.rangeItems.relative.${_vm.futureRange ? 'next' : 'last'}Days`, 7, {
    n: 7
  })) + "\n                  ")])], 1) : _vm._e(), _vm.isValidQuickRange(`now${_vm.mathOp}30d`) ? _c('li', [_c(VBtn, {
    attrs: {
      "text": "",
      "small": ""
    },
    on: {
      "click": function ($event) {
        return _vm.handleQuickRangeClick(`now${_vm.mathOp}30d`);
      }
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.$i18n_tc(`Core.DateTimePicker.rangeItems.relative.${_vm.futureRange ? 'next' : 'last'}Days`, 30, {
    n: 30
  })) + "\n                  ")])], 1) : _vm._e(), _vm.isValidQuickRange(`now${_vm.mathOp}90d`) ? _c('li', [_c(VBtn, {
    attrs: {
      "text": "",
      "small": ""
    },
    on: {
      "click": function ($event) {
        return _vm.handleQuickRangeClick(`now${_vm.mathOp}90d`);
      }
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.$i18n_tc(`Core.DateTimePicker.rangeItems.relative.${_vm.futureRange ? 'next' : 'last'}Days`, 90, {
    n: 90
  })) + "\n                  ")])], 1) : _vm._e(), _vm.isValidQuickRange(`now${_vm.mathOp}6M`) ? _c('li', [_c(VBtn, {
    attrs: {
      "text": "",
      "small": ""
    },
    on: {
      "click": function ($event) {
        return _vm.handleQuickRangeClick(`now${_vm.mathOp}6M`);
      }
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.$i18n_tc(`Core.DateTimePicker.rangeItems.relative.${_vm.futureRange ? 'next' : 'last'}Months`, 6, {
    n: 6
  })) + "\n                  ")])], 1) : _vm._e(), _vm.isValidQuickRange(`now${_vm.mathOp}1y`) ? _c('li', [_c(VBtn, {
    attrs: {
      "text": "",
      "small": ""
    },
    on: {
      "click": function ($event) {
        return _vm.handleQuickRangeClick(`now${_vm.mathOp}1y`);
      }
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.$i18n_tc(`Core.DateTimePicker.rangeItems.relative.${_vm.futureRange ? 'next' : 'last'}Years`, 1, {
    n: 1
  })) + "\n                  ")])], 1) : _vm._e(), _vm.isValidQuickRange(`now${_vm.mathOp}2y`) ? _c('li', [_c(VBtn, {
    attrs: {
      "text": "",
      "small": ""
    },
    on: {
      "click": function ($event) {
        return _vm.handleQuickRangeClick(`now${_vm.mathOp}2y`);
      }
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.$i18n_tc(`Core.DateTimePicker.rangeItems.relative.${_vm.futureRange ? 'next' : 'last'}Years`, 2, {
    n: 2
  })) + "\n                  ")])], 1) : _vm._e(), _vm.isValidQuickRange(`now${_vm.mathOp}5y`) ? _c('li', [_c(VBtn, {
    attrs: {
      "text": "",
      "small": ""
    },
    on: {
      "click": function ($event) {
        return _vm.handleQuickRangeClick(`now${_vm.mathOp}5y`);
      }
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.$i18n_tc(`Core.DateTimePicker.rangeItems.relative.${_vm.futureRange ? 'next' : 'last'}Years`, 5, {
    n: 5
  })) + "\n                  ")])], 1) : _vm._e(), _c('li', {
    staticClass: "text-subtitle-2 quickRangeListSectionHeader"
  }, [_vm._v("\n                  " + _vm._s(_vm.$i18n_t('Core.DateTimePicker.sectionRangesQuick')) + "\n                ")]), _vm.isValidQuickRange('now-1d/d') ? _c('li', [_c(VBtn, {
    attrs: {
      "text": "",
      "small": ""
    },
    on: {
      "click": function ($event) {
        return _vm.handleQuickRangeClick('now-1d/d');
      }
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.$i18n_t('Core.DateTimePicker.rangeItems.quick.yesterday')) + "\n                  ")])], 1) : _vm._e(), _vm.isValidQuickRange('now-2d/d') ? _c('li', [_c(VBtn, {
    attrs: {
      "text": "",
      "small": ""
    },
    on: {
      "click": function ($event) {
        return _vm.handleQuickRangeClick('now-2d/d');
      }
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.$i18n_t('Core.DateTimePicker.rangeItems.quick.dayBeforeYesterday')) + "\n                  ")])], 1) : _vm._e(), _vm.isValidQuickRange('now-7d/d') ? _c('li', [_c(VBtn, {
    attrs: {
      "text": "",
      "small": ""
    },
    on: {
      "click": function ($event) {
        return _vm.handleQuickRangeClick('now-7d/d');
      }
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.$i18n_t('Core.DateTimePicker.rangeItems.quick.thisDayLastWeek')) + "\n                  ")])], 1) : _vm._e(), _vm.isValidQuickRange('now-1w/w') ? _c('li', [_c(VBtn, {
    attrs: {
      "text": "",
      "small": ""
    },
    on: {
      "click": function ($event) {
        return _vm.handleQuickRangeClick('now-1w/w');
      }
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.$i18n_t('Core.DateTimePicker.rangeItems.quick.previousWeek')) + "\n                  ")])], 1) : _vm._e(), _vm.isValidQuickRange('now-1M/M') ? _c('li', [_c(VBtn, {
    attrs: {
      "text": "",
      "small": ""
    },
    on: {
      "click": function ($event) {
        return _vm.handleQuickRangeClick('now-1M/M');
      }
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.$i18n_t('Core.DateTimePicker.rangeItems.quick.previousMonth')) + "\n                  ")])], 1) : _vm._e(), _vm.isValidQuickRange('now-1y/y') ? _c('li', [_c(VBtn, {
    attrs: {
      "text": "",
      "small": ""
    },
    on: {
      "click": function ($event) {
        return _vm.handleQuickRangeClick('now-1y/y');
      }
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.$i18n_t('Core.DateTimePicker.rangeItems.quick.previousYear')) + "\n                  ")])], 1) : _vm._e(), _vm.isValidQuickRange('now/d') ? _c('li', [_c(VBtn, {
    attrs: {
      "text": "",
      "small": ""
    },
    on: {
      "click": function ($event) {
        return _vm.handleQuickRangeClick('now/d');
      }
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.$i18n_t('Core.DateTimePicker.rangeItems.quick.today')) + "\n                  ")])], 1) : _vm._e(), _vm.isValidQuickRange('now/d', true) ? _c('li', [_c(VBtn, {
    attrs: {
      "text": "",
      "small": ""
    },
    on: {
      "click": function ($event) {
        return _vm.handleQuickRangeClick('now/d', true);
      }
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.$i18n_t('Core.DateTimePicker.rangeItems.quick.todaySoFar')) + "\n                  ")])], 1) : _vm._e(), _vm.isValidQuickRange('now/w') ? _c('li', [_c(VBtn, {
    attrs: {
      "text": "",
      "small": ""
    },
    on: {
      "click": function ($event) {
        return _vm.handleQuickRangeClick('now/w');
      }
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.$i18n_t('Core.DateTimePicker.rangeItems.quick.thisWeek')) + "\n                  ")])], 1) : _vm._e(), _vm.isValidQuickRange('now/w', true) ? _c('li', [_c(VBtn, {
    attrs: {
      "text": "",
      "small": ""
    },
    on: {
      "click": function ($event) {
        return _vm.handleQuickRangeClick('now/w', true);
      }
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.$i18n_t('Core.DateTimePicker.rangeItems.quick.thisWeekSoFar')) + "\n                  ")])], 1) : _vm._e(), _vm.isValidQuickRange('now/M') ? _c('li', [_c(VBtn, {
    attrs: {
      "text": "",
      "small": ""
    },
    on: {
      "click": function ($event) {
        return _vm.handleQuickRangeClick('now/M');
      }
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.$i18n_t('Core.DateTimePicker.rangeItems.quick.thisMonth')) + "\n                  ")])], 1) : _vm._e(), _vm.isValidQuickRange('now/M', true) ? _c('li', [_c(VBtn, {
    attrs: {
      "text": "",
      "small": ""
    },
    on: {
      "click": function ($event) {
        return _vm.handleQuickRangeClick('now/M', true);
      }
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.$i18n_t('Core.DateTimePicker.rangeItems.quick.thisMonthSoFar')) + "\n                  ")])], 1) : _vm._e(), _vm.isValidQuickRange('now/y') ? _c('li', [_c(VBtn, {
    attrs: {
      "text": "",
      "small": ""
    },
    on: {
      "click": function ($event) {
        return _vm.handleQuickRangeClick('now/y');
      }
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.$i18n_t('Core.DateTimePicker.rangeItems.quick.thisYear')) + "\n                  ")])], 1) : _vm._e(), _vm.isValidQuickRange('now/y', true) ? _c('li', [_c(VBtn, {
    attrs: {
      "text": "",
      "small": ""
    },
    on: {
      "click": function ($event) {
        return _vm.handleQuickRangeClick('now/y', true);
      }
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.$i18n_t('Core.DateTimePicker.rangeItems.quick.thisYearSoFar')) + "\n                  ")])], 1) : _vm._e()]) : _vm._e(), !_vm.isRange ? _c('ul', {
    staticClass: "quickRangeList"
  }, [_c('li', {
    staticClass: "text-subtitle-2 quickRangeListSectionHeader"
  }, [_vm._v("\n                  " + _vm._s(_vm.$i18n_t('Core.DateTimePicker.sectionRangesRelative')) + "\n                ")]), _c('li', [_c(VBtn, {
    attrs: {
      "text": "",
      "small": ""
    },
    on: {
      "click": function ($event) {
        return _vm.handleQuickRangeClick(`now${_vm.mathOp}1h`);
      }
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.$i18n_tc(`Core.DateTimePicker.rangeItems.relative.${_vm.futureRange ? 'in' : 'past'}Hours`, 1, {
    n: 1
  })) + "\n                  ")])], 1), _c('li', [_c(VBtn, {
    attrs: {
      "text": "",
      "small": ""
    },
    on: {
      "click": function ($event) {
        return _vm.handleQuickRangeClick(`now${_vm.mathOp}2h`);
      }
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.$i18n_tc(`Core.DateTimePicker.rangeItems.relative.${_vm.futureRange ? 'in' : 'past'}Hours`, 2, {
    n: 2
  })) + "\n                  ")])], 1), _c('li', [_c(VBtn, {
    attrs: {
      "text": "",
      "small": ""
    },
    on: {
      "click": function ($event) {
        return _vm.handleQuickRangeClick(`now${_vm.mathOp}3h`);
      }
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.$i18n_tc(`Core.DateTimePicker.rangeItems.relative.${_vm.futureRange ? 'in' : 'past'}Hours`, 3, {
    n: 3
  })) + "\n                  ")])], 1), _c('li', [_c(VBtn, {
    attrs: {
      "text": "",
      "small": ""
    },
    on: {
      "click": function ($event) {
        return _vm.handleQuickRangeClick(`now${_vm.mathOp}6h`);
      }
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.$i18n_tc(`Core.DateTimePicker.rangeItems.relative.${_vm.futureRange ? 'in' : 'past'}Hours`, 6, {
    n: 6
  })) + "\n                  ")])], 1), _c('li', [_c(VBtn, {
    attrs: {
      "text": "",
      "small": ""
    },
    on: {
      "click": function ($event) {
        return _vm.handleQuickRangeClick(`now${_vm.mathOp}12h`);
      }
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.$i18n_tc(`Core.DateTimePicker.rangeItems.relative.${_vm.futureRange ? 'in' : 'past'}Hours`, 12, {
    n: 12
  })) + "\n                  ")])], 1), _c('li', [_c(VBtn, {
    attrs: {
      "text": "",
      "small": ""
    },
    on: {
      "click": function ($event) {
        return _vm.handleQuickRangeClick(`now${_vm.mathOp}24h`);
      }
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.$i18n_tc(`Core.DateTimePicker.rangeItems.relative.${_vm.futureRange ? 'in' : 'past'}Hours`, 24, {
    n: 24
  })) + "\n                  ")])], 1), _c('li', {
    staticClass: "text-subtitle-2 quickRangeListSectionHeader"
  }, [_vm._v("\n                  " + _vm._s(_vm.$i18n_t('Core.DateTimePicker.sectionRangesQuick')) + "\n                ")]), _c('li', [_c(VBtn, {
    attrs: {
      "text": "",
      "small": ""
    },
    on: {
      "click": function ($event) {
        return _vm.handleQuickRangeClick('now/d');
      }
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.$i18n_t('Core.DateTimePicker.rangeItems.quick.today')) + "\n                  ")])], 1), _c('li', [_c(VBtn, {
    attrs: {
      "text": "",
      "small": ""
    },
    on: {
      "click": function ($event) {
        return _vm.handleQuickRangeClick(`now${_vm.mathOp}1d/d`);
      }
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.$i18n_t(`Core.DateTimePicker.rangeItems.quick.${_vm.futureRange ? 'tomorrow' : 'yesterday'}`)) + "\n                  ")])], 1), _c('li', [_c(VBtn, {
    attrs: {
      "text": "",
      "small": ""
    },
    on: {
      "click": function ($event) {
        return _vm.handleQuickRangeClick(`now${_vm.mathOp}2d/d`);
      }
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.$i18n_t(`Core.DateTimePicker.rangeItems.quick.${_vm.futureRange ? 'dayAfterTomorrow' : 'dayBeforeYesterday'}`)) + "\n                  ")])], 1), _c('li', [_c(VBtn, {
    attrs: {
      "text": "",
      "small": ""
    },
    on: {
      "click": function ($event) {
        return _vm.handleQuickRangeClick(`now${_vm.mathOp}1w/d`);
      }
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.$i18n_tc(`Core.DateTimePicker.rangeItems.relative.${_vm.futureRange ? 'in' : 'past'}Weeks`, 1, {
    n: 1
  })) + "\n                  ")])], 1), _c('li', [_c(VBtn, {
    attrs: {
      "text": "",
      "small": ""
    },
    on: {
      "click": function ($event) {
        return _vm.handleQuickRangeClick(`now${_vm.mathOp}1M/d`);
      }
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.$i18n_tc(`Core.DateTimePicker.rangeItems.relative.${_vm.futureRange ? 'in' : 'past'}Months`, 1, {
    n: 1
  })) + "\n                  ")])], 1), _c('li', [_c(VBtn, {
    attrs: {
      "text": "",
      "small": ""
    },
    on: {
      "click": function ($event) {
        return _vm.handleQuickRangeClick(`now${_vm.mathOp}2M/d`);
      }
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.$i18n_tc(`Core.DateTimePicker.rangeItems.relative.${_vm.futureRange ? 'in' : 'past'}Months`, 2, {
    n: 2
  })) + "\n                  ")])], 1), _c('li', [_c(VBtn, {
    attrs: {
      "text": "",
      "small": ""
    },
    on: {
      "click": function ($event) {
        return _vm.handleQuickRangeClick(`now${_vm.mathOp}3M/d`);
      }
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.$i18n_tc(`Core.DateTimePicker.rangeItems.relative.${_vm.futureRange ? 'in' : 'past'}Months`, 3, {
    n: 3
  })) + "\n                  ")])], 1), _c('li', [_c(VBtn, {
    attrs: {
      "text": "",
      "small": ""
    },
    on: {
      "click": function ($event) {
        return _vm.handleQuickRangeClick(`now${_vm.mathOp}6M/d`);
      }
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.$i18n_tc(`Core.DateTimePicker.rangeItems.relative.${_vm.futureRange ? 'in' : 'past'}Months`, 6, {
    n: 6
  })) + "\n                  ")])], 1), _c('li', [_c(VBtn, {
    attrs: {
      "text": "",
      "small": ""
    },
    on: {
      "click": function ($event) {
        return _vm.handleQuickRangeClick(`now${_vm.mathOp}1y/d`);
      }
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.$i18n_tc(`Core.DateTimePicker.rangeItems.relative.${_vm.futureRange ? 'in' : 'past'}Years`, 1, {
    n: 1
  })) + "\n                  ")])], 1)]) : _vm._e()]) : _vm._e()], 1)], 1)], 1)], 1)], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };